import { render, staticRenderFns } from "./useRecord.vue?vue&type=template&id=39764366&scoped=true"
import script from "./useRecord.vue?vue&type=script&lang=js"
export * from "./useRecord.vue?vue&type=script&lang=js"
import style0 from "./useRecord.vue?vue&type=style&index=0&id=39764366&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39764366",
  null
  
)

export default component.exports